import React from "react";
import "./FeaturedLocations.css";
import { FooterFeaturedLocationsSingleLink } from "./FooterFeaturedLocationsSingleLink";
import { useFeaturedLocationsAll } from "../hooks/useFeaturedLocationsAll";

export const FooterFeaturedLocations = React.memo(({ i18n }) => {
  const featuredLocationsAll = useFeaturedLocationsAll();

  false &&
    console.log(
      "❤️❤️❤️ __debug [FooterFeaturedLocations]" +
        JSON.stringify({
          i18n: i18n,
        })
    );
  return (
    <React.Fragment>
      {featuredLocationsAll.map((fl, index) => {
        return (
          <FooterFeaturedLocationsSingleLink
            key={"footer_featured" + fl.node.frontmatter.url_slug + index}
            data={fl}
            i18n={i18n}
          />
        );
      })}
    </React.Fragment>
  );
});
